import React, { Component } from 'react';
import { default as MuiMenu } from '@mui/material/Menu';

export class Menu extends Component {
    content = () => {
        return (
            <MuiMenu               
                id={"usermenu" + this.props.id}
                open={this.props.open}
                onClose={this.props.onClose}
                anchorEl={this.props.anchorEl}
                PaperProps={{
                    elevation: this.props.dark ? 0 : 4,
                    sx: {
                        backgroundColor: (theme) => this.props.dark ? theme.palette.background.paper : theme.palette.background.paper,
                        border: (theme) => this.props.dark ? theme.palette.divider : theme.palette.divider,
                        color: (theme) => this.props.dark ? theme.palette.text.primary : theme.palette.text.primary
                    }
                }}
                MenuListProps={{
                    dense: this.props.width < 600,
                    sx: {
                        backgroundColor: (theme) => this.props.dark ? theme.palette.background.paper : theme.palette.background.paper,
                        color: (theme) => this.props.dark ? theme.palette.text.primary : theme.palette.text.primary
                    }
                }}
            >
                {this.props.children}
            </MuiMenu>
        )

    }


    //main component render
    render() {
        return this.content()
    }
}